module.exports = __webpack_public_path__ + "static/img/404.14de93e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/404_images/404.png
// module id = 9wLW
// module chunks = 1